<template>
  <section class="buy-panel-wrapper-add-to-cart">
    <button
      v-if="signInToBuy"
      @click="addToCart"
      :disabled="disableAddToCart || !enableAddToCartButton"
      :class="buttonClass ? buttonClass : [
        'buy-panel-add-to-cart',
        { 'wide-cta': isAddToCartWideCta && !disableShare },
        'button',
        { 'buy-panel-add-to-cart-loading': addToCartLoading },
        { 'zoom-level-high': zoomLevelHigh},
      ]"
      type="button"
    >
      <span v-show="!addToCartLoading">{{
        isMyAddToCart
          ? translations.buyPanelTmallPurchaseDesign
          : translations.buyPanelAddToCar
      }}</span>
      <base-spinner
        v-show="addToCartLoading"
        size="40"
        class="buy-panel-add-to-cart-spinner"
      ></base-spinner>
    </button>
    <button
      v-else
      role="button"
      :aria-label="translations.buyPanelSignInToBuy"
      :disabled="disableAddToCart || !enableAddToCartButton"
      :class="buttonClass ? buttonClass : ['buy-panel-add-to-cart', 'buy-panel-sign-in-to-buy', 'button', 'secondary']"
      type="button"
      @click="launchSignInToBuy"
    >
      {{ translations.buyPanelSignInToBuy  }}
    </button>
  </section>
</template>
<script>
import baseSpinner from "@/components/Spinner";
import { getLocale } from "@/data/regionInfo";
import { getSafeRedirectUrl, navigateToSafeRedirectUrl } from "@/utils/customizerMessagingSecurity";
import { jwtDecode } from "jwt-decode";

export default {
  name: "addToCart",
  components: {
    baseSpinner,
  },
  props: {
    isAddToCartWideCta: {
      type: Boolean,
      default: false,
    },
    isMyAddToCart: {
      // TODO: refactor and rename this to leverage caid configuration.json
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "customizer",
    },
    disableShare: {
      type: Boolean,
      default: false,
    },
    buttonClass: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      enableAddToCartButton: false,
      addToCartLoading: false,
      allowAddToCart: false,
      userToken: null
    };
  },
  computed: {
    pdm() {
      return this.$store.state.utils.pdm;
    },
    checkSignInToBuyFlag() {
      if(this.type !== 'randomizer'){
        return this.configuration?.vue_component_settings?.buy_panel?.enableSignInToBuy
      } else {
        return this.configuration?.vct_settings?.randomizer?.enableSignInToBuy
      };
    },
    signInToBuy() {
      if(!this.checkSignInToBuyFlag) return true;
      const token = this.userToken;
      const decoded = token ? jwtDecode(token) : false;
      return decoded ? decoded.loggedIn && decoded.loyaltyMember : false || this.allowAddToCart;
    },
    translations() {
      return this.$store.state.translations.data;
    },
    isSizeSelectorDisabled() {
      return this.$store.state.utils.configuration.ugc.disableSizeSelector;
    },
    disableAddToCart() {
      let disableButton = false;
      const cartImageReady = this.$store.state.buyPanel.cartImage;
      this.itemsToPurchase.forEach((item) => {
        if (item.size === "" || (this.isSizeSelectorDisabled && item.size === this.pdm?.ugcDefaultSize)) {
          disableButton = true;
        }
      });
      return disableButton || this.addToCartLoading || !cartImageReady;
    },
    ugcSize() {
      return this.$store.state.buyPanel.ugcSize;
    },
    isUGCApplied() {
      return this.$store.state.buyPanel.isUGCApplied;
    },
    itemsToPurchase() {
      return this.$store.state.buyPanel.itemsToPurchase;
    },
    storedRecipes() {
      return this.$store.state.buyPanel.storedRecipes;
    },
    sizes() {
      return this.$store.state.utils.audienceSizes;
    },
    noEsiActive() {
      return this.$store.getters["utils/noEsiActive"];
    },
    vsfActive() {
      return this.$store.getters["utils/vsfActive"];
    },
    useEcomDataLayerFormat() {
      return this.$store.getters["utils/useEcomDataLayerFormat"];
    },
    isApparelEnabled() {
      return this.$store.getters["utils/isApparelEnabled"];
    },
    configuration() {
      return this.$store.state.utils.configuration;
    },
    canvasActive() {
      return this.$store.getters["utils/canvasActive"];
    },
    zoomLevelHigh() {
      return this.$store.state.utils.zoomLevel >= 200;
    },
  },
  methods: {
    launchSignInToBuy(){
      this.$eventBus.$emit('changeGlobalFocusState', { visible: false });
      this.$eventBus.$emit("customsLaunchSignInToBuy");
    },
    signInToBuyCallback({ body }) {
      this.$eventBus.$emit('changeGlobalFocusState', { visible: true });
      if (body.userLoggedIn) {
        this.allowAddToCart = true;
        this.addToCart();
      } else {
        this.allowAddToCart = false;
        console.error(body.message)
      }
    },
    /**
     * @function getTextSize
     * Return the Text Size from audience_sizes
     */
    getTextSize(identifierSize) {
      const ugcSizeIndex = this.sizes.identifier.indexOf(identifierSize);
      return ugcSizeIndex >= 0
        ? this.sizes.values[ugcSizeIndex]
        : identifierSize;
    },
    toggleAddToCartState(enable) {
      this.enableAddToCartButton = enable;
    },
    openRepositionWarningModal() {
      this.$eventBus.$emit("hide-buy-panel");
      this.$modal.show(
        !!this.$store.state.utils.configuration.modals?.ugcRepositionWarning
          ? "ugcRepositionWarningModal"
          : "NewRepositionWarningModal",
        {
          newUGCSize: this.getTextSize(this.itemsToPurchase[0].size),
          prevUGCSize: this.getTextSize(this.ugcSize),
          sizeIdentifierValue: this.itemsToPurchase[0].size,
          deletePreviousRecipe: true,
          storeMultipleUGCsizes: true,
        }
      );
    },
    /**
     * @function getSku
     * Get product sku by recipe id.
     */
    getSku(recipe_id, size) {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("buyPanel/GET_SKU", {
            recipe_id: recipe_id,
            locale: getLocale(),
            type: this.$props.type,
            size,
          })
          .then((data) => {
            data.recipe_id = recipe_id;
            resolve(data);
          })
          .catch((err) => {
            console.error("Error getting sku:", err);
            reject(err);
          });
      });
    },
    /**
     * @function areValidItemsToPurchase
     * This method verify the items to purchase.
     * Verify if the first item has been changed and it is necessary to
     * make reposition flow before add to cart.
     */
    areValidItemsToPurchase(ugcRecipes) {
      // if size selector is disabled allow add to cart with any size different form ugc
      if (this.$store.state.utils.configuration.ugc.disableSizeSelector)
        return true;

      const recipeSizes = Object.keys(ugcRecipes);
      const { bucketSizes } = this.$store.state.utils;
      let areAllRecipesCreated = true;
      for (let item of this.itemsToPurchase) {
        if (!recipeSizes.includes(bucketSizes[item.size])) {
          areAllRecipesCreated = false;
          break;
        }
      }
      return !(this.isUGCApplied && !areAllRecipesCreated);
    },
    /**
     * @function setRecipesMultipleUGCSizes
     * This method create ugc to get recipe_id.
     */
    setRecipesMultipleUGCSizes(UGCStorage) {
      const recipe = JSON.parse(
        JSON.stringify(this.$store.state.recipe.recipe_v2)
      );
      Object.keys(UGCStorage).forEach((componentName) => {
        recipe.components[componentName].ugc = {};
        recipe.components[componentName].ugc = UGCStorage[componentName];
      });
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("recipe/SAVE_RECIPE", {
            recipe: recipe,
            requestParams: { locale: getLocale() },
            type: this.$props.type,
            skipImageModeration: true
          })
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            console.error("Error getting recipe id:", err);
            reject(err);
          });
      });
    },
    /**
     * @function getPartNumberPromises
     * This method save promises with partNumber response.
     * If we have STORE_UGC items we need to use those recipes.
     * Otherwise, we use the same recipe id.
     */
    getPartNumberPromises() {
      let recipeId;
      let promises = this.itemsToPurchase.map((item, index) => {
        recipeId = this.storedRecipes[index];
        return this.getSku(recipeId, item.size).then((data) => {
          let product = {};
          let suffix = "";
          if (this.itemsToPurchase.length > 1) {
            suffix = "_" + (index + 1);
          }
          product["extRecipeId" + suffix] = data.recipe_id;
          product["partNumber" + suffix] = data.sku;
          product["quantity" + suffix] = item.quantity;
          return product;
        });
      });
      return promises;
    },
    /**
     * @function addToCart
     * Add to cart method using request data.
     */
    addToCart() {
      this.addToCartLoading = true;
      const ugcChecks = this.$store.getters["ugc/getComponentsWithUGCApplied"];
      const libraryChecks = this.$store.getters[
        "ugc/getComponentsByUGCSubgroupApplied"
      ]({ subgroupIdentifier: "library" });
      let ugcRecipes =
        this.$store.getters["ugc/storageController/GET_STORAGE_RECIPES"];
      if (ugcChecks.length > 0 && libraryChecks.length > 0) {
        const recipeComponent = this.$store.getters[
          "imageGallery/getStorageRecipeComponent"
        ]({ activeComponent: libraryChecks[0] });
        const bucketSize =
          this.$store.state.utils.bucketSizes[recipeComponent.ugc.size];
        ugcRecipes = this.$store.getters[
          "imageGallery/getStorageRecipeForBuyPanel"
        ]({
          activeComponent: libraryChecks[0],
          bucketSize: bucketSize,
          ugcObject: recipeComponent.ugc,
        });
      }
      if (this.isMyAddToCart) {
        this.$eventBus.$emit("toggle-save-design-button", true);
      }
      if (!this.areValidItemsToPurchase(ugcRecipes) && !this.isApparelEnabled) {
        this.addToCartLoading = false;
        this.openRepositionWarningModal();
        return;
      }
      // checks if recipe is UGC and there's more than one size/quantity pair
      if (
        Object.keys(ugcRecipes).length > 1 &&
        this.itemsToPurchase.length > 1
      ) {
        let recipePromises = Object.keys(ugcRecipes).map((key) =>
          this.setRecipesMultipleUGCSizes(ugcRecipes[key], key).then(
            (data) => data.recipeId
          )
        );
        Promise.all(recipePromises).then((results) => {
          let recipeIds = [];
          const sizes = Object.keys(ugcRecipes);
          // This use case is when the itemsToPurchase has the same size in two differents select with ugc
          if (recipePromises.length != this.itemsToPurchase.length) {
            for (let item of this.itemsToPurchase) {
              const size = item.size.split(" ")[0];
              const idx = sizes.indexOf(size);
              recipeIds.push(results[idx]);
            }
            results = recipeIds;
          }

          this.$store.commit("buyPanel/SET_STORED_RECIPES", results);
          this.addCustomOrder();
        });
      } else {
        this.addCustomOrder();
      }
    },
    /**
     * @function addCustomerOrder
     * This method send the data to VFAJAx
     */
    addCustomOrder() {
      if (this.useEcomDataLayerFormat) {
        Promise.all(
          this.itemsToPurchase.map(({ size, quantity }, index) =>
            this.getSku(this.storedRecipes[index], size).then(
              ({ recipe_id, sku }) => ({
                recipe: recipe_id,
                productId: sku,
                sku,
                quantity,
                size,
              })
            )
          )
        ).then((orders) => {
          const addToCartEventObject = {
            orders,
            model: this.$store.state.recipe.recipe_v2.pdm,
            "2dImageView":
              this.configuration?.vue_component_settings?.buy_panel
                ?.mini_cart_view ||
              this.$store.state.randomizer.modelsData[
                this.$store.state.recipe.recipe_v2.pdm
              ].featured_views.mini_cart,
            preCreatedCustomCode:
              this.$store.state.utils.queryParams.preCreatedCustomCode,
          };

          if (this.canvasActive) {
            this.canvasAddToCart({ addToCartEventObject });
          }

          if (this.vsfActive) {
            this.setMonetateQ();
            this.$eventBus.$emit("customsAddToCart", addToCartEventObject);
          }
          if (this.$props.type === "customizer") {
            this.$customizerDataLayer.logAnalyticsEvent({
              type: this.$customizerDataLayer.types.customizerBuyPanel,
              eventLabel: "Add to Cart",
            });
          }
        });
      } else {
        const promises = this.getPartNumberPromises();
        Promise.all(promises)
          .then((results) => {
            let products = Object.assign(...results);
            let requestData = {
              catalogId: this.$store.state.utils.configuration.catalogId,
              storeId: this.$store.state.utils.configuration.storeId,
              langId: this.$store.state.utils.configuration.langId,
              model: this.$store.state.recipe.recipe_v2.pdm,
              action: "add",
              ...products,
            };

            try {
              const { sessionId } = this.$store.state.utils.configuration;
              const { env } = this.$store.state.utils;
              if (!!sessionId && sessionId[env]) {
                const cookieValue = sessionId[env]
                  ? this.$cookies.get(sessionId[env])
                  : null;
                if (cookieValue) requestData.sessionId = cookieValue;
              }
            } catch (err) {
              // Handle error for add your touch
              // Needed because add your touch doesn't load this module
            }

            if (this.isMyAddToCart) {
              this.myAddToCart(requestData).then(() => {
                this.handleResetCart();
                return;
              });
            } else {
              this.defaultAddToCart(requestData).then(() => {
                this.handleResetCart();
                return;
              });
            }
          })
          .catch((err) => {
            console.error("Error getting sku", err);
          });
      }
    },

    async canvasAddToCart({ addToCartEventObject }) {
      const locale =  getLocale().replace("_","-");
      const emptyBasketId = await this.$store.dispatch(
        "buyPanel/FETCH_BASKET_ID", {locale}
      );
      const basketId = await emptyBasketId.json();
      const recipe_id = this.$store.state.recipe.recipe_v2.recipe_id;
      const productImageURL = this.$store.state.buyPanel.cartImage;
      const pdpUrl = `${window.parent.location.origin}/${locale}/customizer/${this.$store.state.recipe.recipe_v2.pdm}?recipe=${recipe_id}`;
      if(this.type === "randomizer") {
        await this.$store
          .dispatch("ugc/tempData/GET_PRODUCT_IMAGES_BY_RECIPE_ID", {
            locale: getLocale(),
            recipe_id,
            size: "lg-pdp-white",
            view: "left_pdp",
            type: this.type
          })
      }

     const addToCart = await this.$store.dispatch(
        "buyPanel/ADD_TO_CART_CANVAS",
        {
          basketId: basketId.id,
          productId: addToCartEventObject.orders[0].productId,
          quantity: addToCartEventObject.orders[0].quantity,
          pdpUrl,
          productImageURL,
          recipeId: addToCartEventObject.orders[0].recipe,
          locale
        }
      );

      addToCart.json().then((data) => {
        // do minicart stuff here
        this.addToCartLoading = false;
        this.$eventBus.$emit("hide-buy-panel");
        this.$iframeCommunicator.postMessage({ command: 'customsProductAddedToCart' });
      });
    },

    /**
     * @function defaultAddToCart
     * @param {object} requestData - Data contain the information needed for add to cart
     * This method send the requestData object ot he add to cart endpoint for WCS,Shopex or breeze.
     */
    defaultAddToCart(requestData) {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("buyPanel/ADD_TO_CART", {
            data: requestData,
            type: this.$props.type,
          })
          .then(({ action, redirectUrl }) => {
            const shouldRedirect = action && action === "redirect";
            const safeRedirectUrl = shouldRedirect ? getSafeRedirectUrl(redirectUrl) : null;

            if (shouldRedirect && !safeRedirectUrl) {
              navigateToSafeRedirectUrl(redirectUrl, { context: "defaultAddToCart" });
              this.addToCartLoading = false;
              resolve();
              return;
            }

            this.$emit("add-to-cart", this.itemsToPurchase[0]);

            if (this.$props.type === "customizer") {
              // Clear onbeforeunload event
              this.$eventBus.$emit("set-onbeforeunload");
            }
            this.setMonetateQ();
            if (shouldRedirect) {
              // IF ACTION, AND ACTION IS REDIRECT - REDIRECT PAGE(EG: SHOPEX CART)
              window.location.href = safeRedirectUrl;
            } else {
              this.$eventBus.$emit("hide-buy-panel");
              const { bundle_partnumber, pdm } =
                this.$store.state.recipe.recipe_v2;
              const globalCart = document.getElementById(
                "global-cart-wishlist-panels"
              );
              if (
                globalCart &&
                globalCart.classList.contains("l-top") &&
                this.$utils
              ) {
                this.$eventBus.$emit("changeExternalHeadersVisibility", "show");
              }

              // WCS Dependency can't be removed, this is needed to open the mini cart in WCS
              if (typeof $ !== "undefined" && $.pubsub) {
                $.pubsub(
                  "publish",
                  "vfdp.wcs.product_form.add_to_cart_succeeded"
                );
                $.pubsub("publish", "SHOPCART_UPDATED.add", {
                  product: [
                    {
                      bundleId: bundle_partnumber,
                      name: pdm,
                      itemId: null,
                      productId: null,
                    },
                  ],
                  action: "add",
                });
              }

              this.setDataLayer();
            }
            //Save recipe object
            this.$store.commit(
              "recipe/SET_SAVED_RECIPE",
              this.$store.state.recipe.recipe_v2
            );
            this.addToCartLoading = false;
            resolve();
          })
          .catch((err) => {
            console.error("Error adding to cart:", err);
            if (err.response && err.response.status === 400) {
              reject(err);
            }
          });
      });
    },
    /**
     * @function defaultAddToCart
     * @param {object} requestData - Data contain the information needed for add to cart
     * This method send the requestData object ot he add to cart endpoint for the Tmall miniapp.
     */
    myAddToCart(requestData) {
      return new Promise((resolve, reject) => {
        if (typeof my !== "undefined") {
          my.onMessage = function (message) {
            const tmallModalSubTitle = `Topic: ${message.topic}`;
            const tmallModalDesc = `message.action: ${
              message.action
            }<br>message.value: ${message.value}<br>message.detail: ${
              message.detail
            }<br>messageJSON: ${JSON.stringify(message)}`;
            console.info("tmallMiniappMessagesModal", {
              tmallModalSubTitle,
              tmallModalDesc,
            });
            this.$eventBus.$emit("hide-buy-panel");
            const { bundle_partnumber, pdm } =
              this.$store.state.recipe.recipe_v2;
            //Save recipe object
            this.$store.commit(
              "recipe/SET_SAVED_RECIPE",
              this.$store.state.recipe.recipe_v2
            );
            resolve();
          };
          my.postMessage({
            topic: "addToCart",
            action: "add",
            sku: requestData.partNumber,
            model: requestData.model,
            recipeId: requestData.extRecipeId,
            qty: requestData.quantity,
          });
        } else {
          console.error("No miniapp my object was found");
          reject(
            new Error("Error on Add To Cart: No miniapp my object was found")
          );
        }
      });
    },
    handleAddToCart({ body } = {}) {
      if (!body || typeof body !== "object") {
        console.warn("AddToCart - handleAddToCart rejected message", { reason: "invalid-body" });
        this.addToCartLoading = false;
        return;
      }

      const shouldRedirect = body.redirectUrl && body.action && body.action === "redirect";
      const safeRedirectUrl = shouldRedirect ? getSafeRedirectUrl(body.redirectUrl) : null;

      if (shouldRedirect && !safeRedirectUrl) {
        navigateToSafeRedirectUrl(body.redirectUrl, { context: "handleAddToCart" });
        this.addToCartLoading = false;
        return;
      }

      if (this.noEsiActive && body.status === "error") {
        console.error("AddToCart - handleAddToCart: ", body.message);
        this.addToCartLoading = false;
      } else if (this.vsfActive && body.status === "error") {
        console.error("AddToCart - handleAddToCart: ", body.message);
        this.addToCartLoading = false;
      } else {
        if (body.preCreatedCustomCodes && body.preCreatedCustomCodes.length) {
          if (this.$props.type === "randomizer") {
            this.itemsToPurchase[0].precreatedCustomCode =
              body.preCreatedCustomCodes[0];
          }
        }

        if (body.totalItems) {
          this.$store.commit("utils/SET_QUERY_PARAMS", {
            totalItems: body.totalItems,
          });
        }

        this.$emit("add-to-cart", this.itemsToPurchase[0]);

        if (this.$props.type === "customizer") {
          // Clear onbeforeunload event
          this.$eventBus.$emit("set-onbeforeunload");
        }

        if (shouldRedirect) {
          // IF ACTION, AND ACTION IS REDIRECT - REDIRECT PAGE(EG: SHOPEX CART)
          window.location.href = safeRedirectUrl;
        } else {
          this.$eventBus.$emit("hide-buy-panel");
          const { bundle_partnumber, pdm } = this.$store.state.recipe.recipe_v2;
          const globalCart = document.getElementById(
            "global-cart-wishlist-panels"
          );
          if (
            globalCart &&
            globalCart.classList.contains("l-top") &&
            this.$utils
          ) {
            this.$eventBus.$emit("changeExternalHeadersVisibility", "show");
          }

          // WCS Dependency can't be removed, this is needed to open the mini cart in WCS
          if (typeof $ !== "undefined" && $.pubsub) {
            $.pubsub("publish", "vfdp.wcs.product_form.add_to_cart_succeeded");
            $.pubsub("publish", "SHOPCART_UPDATED.add", {
              product: [
                {
                  bundleId: bundle_partnumber,
                  name: pdm,
                  itemId: null,
                  productId: null,
                },
              ],
              action: "add",
            });
          }
          if (!this.useEcomDataLayerFormat) {
            this.setDataLayer();
          }
        }
        //Save recipe object
        this.$store.commit(
          "recipe/SET_SAVED_RECIPE",
          this.$store.state.recipe.recipe_v2
        );
        this.handleResetCart();
        this.addToCartLoading = false;
      }
    },
    enableButtons() {
      this.addToCartLoading = false;
      this.disableAddToCartButton = false;
      if (this.isMyAddToCart) {
        this.$eventBus.$emit("toggle-save-design-button", false);
      }
    },
    handleResetCart() {
      this.$store.commit("buyPanel/RESET_STORED_RECIPES");
      this.$store.commit("buyPanel/RESET_ITEMS_TO_PURCHASE");
      this.enableButtons();
      if (this.sizes.identifier.length === 1) {
        this.$eventBus.$emit("get-osfa-size");
      }
    },
    setMonetateQ() {
      if (this.$customsMonetateQ) {
        const { recipeId } = this.$store.state.recipe;
        const { itemsToPurchase, sku, price } = this.$store.state.buyPanel;
        const addToCartPayload = itemsToPurchase.map(({ quantity }) => ({
          productId: recipeId,
          sku,
          quantity,
          currency: price.currency,
          unitPrice: Number(price.decimal),
        }));
        const addProductDetailsPayload = itemsToPurchase.map(
          ({ quantity }) => ({
            productId: recipeId,
            sku,
          })
        );
        this.$customsMonetateQ.logEvent(
          this.$customsMonetateQ.type.addCartRows,
          addToCartPayload
        );
        this.$customsMonetateQ.logEvent(
          this.$customsMonetateQ.type.addProductDetails,
          addProductDetailsPayload
        );
      }
    },
    setDataLayer() {
      const { recipe_v2 } = this.$store.state.recipe;
      const dataLayerSource = this.canvasActive ? parent.dataLayer : dataLayer;

      dataLayerSource.push({
        name: recipe_v2.pdm,
        bundleId: recipe_v2.bundle_partnumber,
        event: "trackEvent",
        eventCategory: "customs",
        eventAction: "BuyPanel",
        eventLabel: "Add To Cart Succeeded",
      });

      if (this.$props.type === "customizer") {
        const { pdm } = this.$store.state.utils;
        const { itemsToPurchase, sku } = this.$store.state.buyPanel;
        const { recipeId } = this.$store.state.recipe;
        const price = this.$store.state.buyPanel.price;
        const products = itemsToPurchase.map(({ size, quantity }) => ({
          name: pdm.product_name,
          id: recipeId,
          bundleID: pdm.partnumber,
          productID: recipeId,
          itemID: sku,
          vn: sku,
          price: Number(price.decimal),
          brand: "vans",
          category: "",
          variant: "",
          quantity,
          styleCode: "",
          colorCode: "",
          colorDescription: "",
          size,
        }));

        dataLayer.push({
          event: "addToCart",
          recipeId,
          ecommerce: {
            currencyCode: price.currency,
            currencySymbol: price.string.replace(price.decimal, ""),
            add: {
              actionField: { list: "customizer" },
              products,
            },
          },
        });
      }
    },
    checkSignInToBuy() {
      this.userToken = this.$cookies.get("vfa_VANS-US_li");
      this.allowAddToCart = this.userToken ? true : false;
    }
  },
  created() {
    this.$eventBus.$on("enable-add-to-cart-button", this.toggleAddToCartState);
    this.$eventBus.$on("addToCart", this.handleAddToCart);
    this.$eventBus.$on("parentAddToCart", this.handleAddToCart);
    this.$store.commit(
      "utils/SET_USER_AUTH",
      `Bearer ${this.$cookies.get("vfa_VANS-US_access")}`
    );
    this.$eventBus.$on("customsAddToCartSignInToBuy", this.signInToBuyCallback);
    this.$eventBus.$on('buypanel-open', this.checkSignInToBuy);
  },
  beforeDestroy() {
    this.$eventBus.$off("enable-add-to-cart-button", this.toggleAddToCartState);
    this.$eventBus.$off("addToCart", this.handleAddToCart);
    this.$eventBus.$off("parentAddToCart", this.handleAddToCart);
    this.$eventBus.$off("customsAddToCartSignInToBuy", this.signInToBuyCallback);
    this.$eventBus.$off('buypanel-open', this.checkSignInToBuy);
  },
};
</script>
